// имя генерируется react-datepicker, при смене проверить стили в Calendar.tsx
export const datepickerName = 'react-datepicker';

export const OFFSET_TIMEZONE_MSK = 3;
export const START_EVENING_HOUR = 18;
export const rightArrowSymbol = '\u2192';
